(function () {
  var PARAM_NAME = 'lx_image_context';
  var RETRY_DELAY = 400;
  var MAX_RETRIES = 75;

  function normalizeContext(value) {
    if (!value) return '';

    var v = String(value)
      .toLowerCase()
      .trim()
      .replace(/\+/g, ' ')
      .replace(/_/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    var aliases = {
      'mothersday': 'mothers-day',
      'fathersday': 'fathers-day',
      'valentinesday': 'valentines-day',
      'newbaby': 'new-baby',
      'housewarming': 'house-warming',
      'memorialsympathy': 'memorial-sympathy',
      'forher': 'for-her',
      'forhim': 'for-him',
      'forbaby': 'for-baby',
      'forthefamily': 'for-the-family',
      'forcoach': 'for-coach',
      'servicerecognition': 'service-recognition',
      'salesachievement': 'sales-achievement',
      'teamwork': 'team-work'
    };

    return aliases[v] || v;
  }

  function getContextFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return normalizeContext(params.get(PARAM_NAME));
    } catch (e) {
      return '';
    }
  }

  function getSearchableText(el) {
    if (!el) return '';

    var parts = [];

    function add(value) {
      if (value) parts.push(String(value).toLowerCase());
    }

    add(el.textContent);
    add(el.innerText);
    add(el.innerHTML);

    var attrNames = [
      'alt',
      'title',
      'aria-label',
      'data-alt',
      'data-title',
      'data-image-alt',
      'data-thumb-alt',
      'data-thumb-title',
      'data-caption',
      'data-label',
      'href',
      'src',
      'currentSrc'
    ];

    attrNames.forEach(function (attr) {
      try {
        add(el.getAttribute && el.getAttribute(attr));
      } catch (e) {}
      try {
        add(el[attr]);
      } catch (e) {}
    });

    var descendants = el.querySelectorAll ? el.querySelectorAll('*') : [];
    descendants.forEach(function (node) {
      attrNames.forEach(function (attr) {
        try {
          add(node.getAttribute && node.getAttribute(attr));
        } catch (e) {}
        try {
          add(node[attr]);
        } catch (e) {}
      });
      add(node.textContent);
    });

    return parts.join(' ');
  }

  function getCandidateThumbnails() {
    var selectors = [
      '.cl-po--gallery-thumbnail',
      '.cl-po--gallery-wrapper .cl-po--gallery-thumbnail',
      '.cl-po--gallery-wrapper [class*="gallery-thumbnail"]',
      '.cl-po--gallery-wrapper .slick-slide',
      '.cl-po--gallery-wrapper .swiper-slide',
      '.cl-po--gallery-wrapper li',
      '.cl-po--gallery-wrapper img'
    ];

    var seen = new Set();
    var results = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!seen.has(el)) {
          seen.add(el);
          results.push(el);
        }
      });
    });

    return results;
  }

  function findMatchingThumbnail(context) {
    if (!context) return null;

    var token = 'lxi-context:' + context;
    var candidates = getCandidateThumbnails();

    for (var i = 0; i < candidates.length; i++) {
      var text = getSearchableText(candidates[i]);
      if (text.indexOf(token) !== -1) {
        return candidates[i];
      }
    }

    return null;
  }

  function clickThumbnail(el) {
    if (!el) return false;

    var clickable =
      el.closest('button, a') ||
      el.querySelector('button, a') ||
      el.querySelector('img') ||
      el;

    try {
      clickable.click();
      clickable.dispatchEvent(
        new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        })
      );
      return true;
    } catch (e) {
      return false;
    }
  }

  function applyContextThumbnail() {
    var context = getContextFromUrl();
    if (!context) return false;

    var token = 'lxi-context:' + context;

    var wrapper = document.querySelector('.cl-po--gallery-wrapper');
    if (!wrapper) return false;

    var match = findMatchingThumbnail(context);
    if (!match) return false;

    if (document.documentElement.getAttribute('data-lxi-context-applied') === token) {
      return true;
    }

    var clicked = clickThumbnail(match);

    if (clicked) {
      document.documentElement.setAttribute('data-lxi-context-applied', token);
      return true;
    }

    return false;
  }

  function startWatcher() {
    var context = getContextFromUrl();
    if (!context) return;

    var attempts = 0;

    applyContextThumbnail();

    var retryTimer = setInterval(function () {
      attempts++;
      var applied = applyContextThumbnail();

      if (applied || attempts >= MAX_RETRIES) {
        clearInterval(retryTimer);
      }
    }, RETRY_DELAY);

    var observer = new MutationObserver(function () {
      applyContextThumbnail();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, (MAX_RETRIES * RETRY_DELAY) + 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatcher);
  } else {
    startWatcher();
  }

  window.addEventListener('pageshow', startWatcher);
})();